import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportSalesByCstRequest } from './SalesByCst.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportSalesByCst(
  params: QuestReportSalesByCstRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/SalesByCst`,
    params,
  )) as unknown;

  return result as BlobPart;
}
